import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { putEmployeeGovtIdDetailsRequest, putEmployeeGovtIdDetailsSuccess, putEmployeeGovtIdDetailsFailure } from '../actions/employee-detail.actions';
import { IEmployeeGovtIdDetailsPutRequest, IEmployeeGovtIdDetailsPutResponse } from '../models/employee-govt-id-details.model';

export const employeeGovtIdDetailsKey = 'employeeGovtIdDetails';

export interface EmployeeGovtIdDetailsState {
  employeeGovtIdDetailsRequest: IEmployeeGovtIdDetailsPutRequest | null;
  employeeGovtIdDetailsResponse: IEmployeeGovtIdDetailsPutResponse[] | null;
  employeeGovtIdDetailsFailure: IGenericError<ErrorResponse> | null;
}

export const initialState: EmployeeGovtIdDetailsState = {
  employeeGovtIdDetailsRequest: null,
  employeeGovtIdDetailsResponse: null,
  employeeGovtIdDetailsFailure: null
};

export const reducer = createReducer(
  initialState,

  on(putEmployeeGovtIdDetailsRequest, (state, action) => ({
    ...state,
    employeeGovtIdDetailsRequest: action.request
  })),
  on(putEmployeeGovtIdDetailsSuccess, (state, action) => ({
    ...state,
    employeeGovtIdDetailsResponse: action.response
  })),
  on(putEmployeeGovtIdDetailsFailure, (state, action) => ({
    ...state,
    employeeGovtIdDetailsFailure: action.error
  }))
);

export const getEmployeeGovtIdDetailsRequest = (state: EmployeeGovtIdDetailsState) => state.employeeGovtIdDetailsRequest;
export const getEmployeeGovtIdDetailsResponse = (state: EmployeeGovtIdDetailsState) => {
  return state.employeeGovtIdDetailsResponse;
};
export const getEmployeeGovtIdDetailsFailure = (state: EmployeeGovtIdDetailsState) => state.employeeGovtIdDetailsFailure;
